import * as App from "./App";
import "./App"

async function sendMikaRequest(resource = '', params = {}) {
    const data = new FormData();
    for (const param in params) {
        data.append(param, params[param]);
    }
    const resp = await fetch(App.mikaServerEndpoint + `/${resource}?app_key=${global.appKey}`, {
        method: "POST",
        body: data

    }).catch((err) => {
        console.error(err);
    });
    if (resp != null && resp.ok) {
        const jsonObj = await resp.clone().json();
        jsonObj.text = resp.clone().text;
        jsonObj.ok = resp.ok;
        return jsonObj;
    } else {
        console.warn(resp ? await resp.clone().text() : "Failed to contact server.");
        return resp;
    }
}

export async function getAvailableSessions() {
    return sendMikaRequest('getAvailableSessions');
}

export async function deleteSession(sesId) {
    return sendMikaRequest("deleteSession", {ses_id: sesId});
}

export async function getSessionInfo(sesId) {
    return sendMikaRequest("getSessionInfo", {ses_id: sesId});
}

export async function createSession(name = "") {
    return sendMikaRequest("createSession", {ses_name: name});
}

export async function updateSessionName(sesId, name = "") {
    return sendMikaRequest("updateSessionName", {ses_id: sesId, ses_name: name});
}

export async function removePlayerFromSession(sesId, player) {
    return sendMikaRequest("removePlayerFromSession", {ses_id: sesId, player_info: JSON.stringify(player)});
}

export async function getUpdatedZones() {
    return sendMikaRequest("getUpdatedZones");
}

export async function addZone(zone) {
    return sendMikaRequest("addZone", {
        zone: JSON.stringify(zone),
        username: global.username,
        password: global.password
    });
}

export async function updateZone(zone) {
    return sendMikaRequest("updateZone", {
        zone: JSON.stringify(zone),
        username: global.username,
        password: global.password
    });
}

export async function removeZone(zId) {
    return sendMikaRequest("removeZone", {zid: zId, username: global.username, password: global.password});
}

export async function getUpdatedQuestions() {
    return sendMikaRequest("getUpdatedQuestions");
}

export async function downloadAnalytics() {
    return sendMikaRequest("downloadAnalytics", {username: global.username, password: global.password});
}

export async function addQuestion(question) {
    return sendMikaRequest("addQuestion", {
        question: JSON.stringify(question),
        username: global.username,
        password: global.password
    });
}

export async function updateQuestion(question) {
    return sendMikaRequest("updateQuestion", {
        question: JSON.stringify(question),
        username: global.username,
        password: global.password
    });
}

export async function removeQuestion(qId) {
    return sendMikaRequest("removeQuestion", {qid: qId, username: global.username, password: global.password});
}

export async function checkMikaResponseSuccess(resp) {
    console.log(resp);
    if (resp == null || !resp.success) {
        let error;
        if (resp == null) error = "Errore di comunicazione con il server.";
        else if (!resp.ok) error = await resp.clone().text();
        else error = resp.content;
        console.error(error);
        alert(error);
        return false;
    }
    return true;
}